import { render, staticRenderFns } from "./ExpedientesMovements.vue?vue&type=template&id=7d59124f&scoped=true&"
import script from "./ExpedientesMovements.vue?vue&type=script&lang=js&"
export * from "./ExpedientesMovements.vue?vue&type=script&lang=js&"
import style0 from "./ExpedientesMovements.vue?vue&type=style&index=0&id=7d59124f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d59124f",
  null
  
)

export default component.exports